import { z } from 'zod';

export enum ProductType {
  Generic = 'Generic',
  TrihowPad = 'TrihowPad',
}

export const ProductTypeSchema = z.nativeEnum(ProductType);
